import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { VALID_EMAIL_REGEX } from '../../config/app_config';
import ForgotPasswordForm from './ForgotPasswordForm';
import { sendForgotPasswordEmail } from '../../actions/authentication';

const FORM_ID = 'forgotPasswordForm';

export class ForgotPasswordFormContainer extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    invalid: PropTypes.bool.isRequired,
    sendForgotPasswordEmailAction: PropTypes.func.isRequired,
  };

  performSendForgotPasswordEmail = params => {
    const { sendForgotPasswordEmailAction } = this.props;
    sendForgotPasswordEmailAction(params.userEmail);
  };

  render() {
    const { handleSubmit, invalid, submitting } = this.props;

    return (
      <ForgotPasswordForm
        handleSubmit={handleSubmit}
        invalid={invalid}
        submitting={submitting}
        sendForgotPasswordEmailFunction={this.performSendForgotPasswordEmail}
      />
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values.userEmail || values.userEmail === '') {
    errors.userEmail = 'Required';
  } else if (!VALID_EMAIL_REGEX.test(values.userEmail)) {
    errors.userEmail = 'Invalid email address';
  }
  return errors;
};

const ForgotPasswordFormContainerRF = reduxForm({
  form: FORM_ID,
  validate,
})(ForgotPasswordFormContainer);

export default connect(null, {
  sendForgotPasswordEmailAction: sendForgotPasswordEmail,
})(ForgotPasswordFormContainerRF);
